import React from 'react';
import Section from '../ui/Section';
import { team } from '../../data/team';
import { Linkedin, Brain, Star, Users, TrendingUp, BookOpen, Lightbulb, Rocket, Target, Shield } from 'lucide-react';

const Team: React.FC = () => {
  const getHighlights = (name: string) => {
    if (name === "Diana Almeida") {
      return [
        {
          icon: <Brain className="text-primary" size={24} />,
          title: "ML Product Leadership",
          description: "Leading AI initiatives at Booking.com"
        },
        {
          icon: <Star className="text-primary\" size={24} />,
          title: "15+ Years Experience",
          description: "Deep expertise in product management"
        },
        {
          icon: <Users className="text-primary" size={24} />,
          title: "Mentor & Leader",
          description: "Empowering women in tech"
        },
        {
          icon: <TrendingUp className="text-primary\" size={24} />,
          title: "Innovation Driver",
          description: "Advancing Responsible & Generative AI"
        }
      ];
    } else {
      return [
        {
          icon: <Rocket className="text-primary" size={24} />,
          title: "GenAI Pioneer",
          description: "Led Booking.com's AI Trip Planner launch"
        },
        {
          icon: <Target className="text-primary\" size={24} />,
          title: "20+ Years Experience",
          description: "Proven track record in tech leadership"
        },
        {
          icon: <Lightbulb className="text-primary" size={24} />,
          title: "Innovation Expert",
          description: "Driving AI transformation at scale"
        },
        {
          icon: <Shield className="text-primary\" size={24} />,
          title: "Strategic Advisor",
          description: "Guiding teams through AI adoption"
        }
      ];
    }
  };

  return (
    <Section>
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">Meet Our Team</h2>
        <p className="text-lg text-neutral-300 max-w-2xl mx-auto text-justify">
          With decades of combined experience in AI and product management, our team brings deep expertise to every client engagement.
        </p>
      </div>
      
      <div className="max-w-6xl mx-auto space-y-32">
        {team.map((member) => (
          <div key={member.id} className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative group">
              <div className="overflow-hidden rounded-2xl">
                <img 
                  src={member.image} 
                  alt={member.name} 
                  className="w-full aspect-square object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="absolute bottom-4 left-4 right-4 flex justify-center space-x-4">
                <a 
                  href={member.name === "Diana Almeida" ? "https://www.linkedin.com/in/dianaalmeida/" : "https://www.linkedin.com/in/nataliehalimi/"} 
                  className="bg-background/90 backdrop-blur-sm p-3 rounded-full text-primary hover:bg-primary/20 transition-colors"
                  aria-label={`${member.name}'s LinkedIn profile`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Linkedin size={20} />
                </a>
                {member.name === "Natalie Halimi" && (
                  <a 
                    href="https://medium.com/@natalie.halimi"
                    className="bg-background/90 backdrop-blur-sm p-3 rounded-full text-primary hover:bg-primary/20 transition-colors"
                    aria-label="Natalie's Medium blog"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <BookOpen size={20} />
                  </a>
                )}
              </div>
            </div>
            
            <div>
              <div className="mb-8">
                <h3 className="text-2xl font-bold mb-2">{member.name}</h3>
                <p className="text-primary text-lg mb-6">{member.position}</p>
                <p className="text-neutral-300 leading-relaxed text-justify">{member.bio}</p>
              </div>
              
              <div className="grid grid-cols-2 gap-4">
                {getHighlights(member.name).map((highlight, index) => (
                  <div key={index} className="bg-neutral-900/50 rounded-xl p-4 border border-neutral-800 hover:border-primary/50 transition-colors">
                    <div className="h-10 w-10 bg-primary/10 rounded-lg flex items-center justify-center mb-3">
                      {highlight.icon}
                    </div>
                    <h4 className="font-semibold mb-1 text-sm">{highlight.title}</h4>
                    <p className="text-sm text-neutral-300 leading-snug">{highlight.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default Team;